import { DatViewer } from "./DatViewer";

export default function DatViewerPage() {
  return <DatViewer open style={{ width: '100%', height: '100%', background: 'lightgray' }} />;
}
